import type { Dictionary } from './en'

export const it = {
  nav: { features: 'Funzioni', pricing: 'Prezzo', faq: 'Domande', account: 'Il mio account', signIn: 'Accedi' },

  hero: {
    title: 'Alt-Tab per il tuo Mac',
    tagline: 'macOS cambia app. AppSwitch fa cambiare finestra a ⌥Tab — tutte le finestre, compresi i tre documenti aperti nella stessa app.',
    download: 'Scarica per Mac',
    seePricing: 'Vedi il prezzo',
    note: 'Gratis · macOS 15 o successivo · Apple silicon e Intel',
    hint: 'Tieni premuto ⌥ e premi Tab — rilascia per passare',
  },

  features: {
    heading: 'Per chi tiene venti finestre aperte',
    sub: 'Una pressione di ⌥Tab le mostra tutte. Rilasci e sei arrivato.',
    items: [
      { title: 'Ogni finestra, non ogni app', body: 'Il selettore di macOS passa tra le app. AppSwitch passa tra le finestre — compresi i tre documenti aperti nella stessa app.' },
      { title: 'Prima la tastiera', body: '⌥Tab per avanzare, ⌥⇧Tab per tornare indietro, frecce per muoverti nella griglia. Rilascia ⌥ e la finestra scelta passa in primo piano.' },
      { title: 'Non ruba mai il focus', body: 'La tua app resta attiva finché non scegli davvero. AppSwitch vive nella barra dei menu, senza icona nel Dock tra i piedi.' },
      { title: 'Anteprime dal vivo', body: 'Vedi il contenuto reale di ogni finestra invece di un’icona generica. Le finestre ridotte a icona compaiono direttamente nel selettore.' },
    ],
  },

  pricing: {
    heading: 'Compralo una volta. È tuo.',
    sub: 'Il selettore è gratuito e completo — non è una prova né una versione ridotta. Pro aggiunge le due funzioni che richiedono una licenza.',
    free: 'Gratis', pro: 'Pro', ribbon: 'Acquisto unico',
    freePrice: '0 €', once: 'una volta',
    freeSub: 'Tutto il necessario per smettere di usare ⌘Tab.',
    proSub: 'Nessun abbonamento. Non si rinnova mai nulla.',
    freeList: [
      'Selettore di finestre completo su ⌥Tab',
      'Navigazione con tastiera e mouse',
      'Vista a griglia e a elenco',
      'App nella barra dei menu, senza icona nel Dock',
    ],
    proList: [
      'Tutto quello della versione gratuita',
      'Anteprime dal vivo di ogni finestra',
      'Finestre ridotte a icona nel selettore',
      'Due Mac per licenza',
    ],
    download: 'Scarica', buy: 'Ottieni AppSwitch Pro', buyBusy: 'Apertura del pagamento…',
    freeFoot: 'Nessun account. Nessuna carta. Nessuna scadenza.',
  },

  faq: {
    heading: 'Domande',
    items: [
      { q: 'Perché AppSwitch ha bisogno di Accessibilità?', a: 'È l’unico modo in cui macOS permette a un’app di intercettare ⌥Tab prima delle altre, elencare le finestre e portarne una in primo piano. Senza, l’app non può funzionare. Lo concedi tu in Impostazioni di Sistema e puoi revocarlo quando vuoi.' },
      { q: 'È un abbonamento?', a: 'No. AppSwitch Pro è un acquisto unico. Nulla si rinnova, nulla viene riaddebitato, e gli aggiornamenti della versione principale attuale sono inclusi.' },
      { q: 'Su quanti Mac posso usarlo?', a: 'Due per licenza. Puoi liberare un posto in qualsiasi momento dal tuo account o dall’app: cambiare macchina non è mai una richiesta di assistenza.' },
      { q: 'I titoli delle mie finestre vengono inviati da qualche parte?', a: 'No. Nessun contenuto di finestra, nessun titolo e nessuna battitura lascia il tuo Mac. L’unica richiesta di rete è la verifica della licenza, e solo se hai acquistato Pro. La versione gratuita non tocca mai la rete.' },
      { q: 'Quali versioni di macOS sono supportate?', a: 'macOS 15 o successivo, su Apple silicon e Intel.' },
    ],
  },

  listMode: {
    heading: 'Due modi di vedere le tue finestre',
    sub: 'Si passa dall’uno all’altro dalla barra dei menu, o con il tasto , mentre il selettore è aperto.',
    grid: { title: 'Griglia, con anteprime', body: 'Miniature del contenuto reale. Ideale quando riconosci una finestra da ciò che mostra.' },
    list: { title: 'Elenco, con titoli completi', body: 'Una colonna densa in cui il titolo intero di ogni finestra sta su una riga. Ideale per venti terminali, o file i cui nomi differiscono solo alla fine.' },
  },

  footer: { terms: 'Condizioni d’uso', privacy: 'Privacy' },

  consent: {
    text: 'Usiamo Google Analytics per capire quali pagine sono utili. Nulla viene misurato senza il tuo consenso. Vedi la nostra',
    privacyLink: 'informativa sulla privacy',
    accept: 'Accetta', decline: 'Rifiuta',
  },
} satisfies Dictionary
